import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";

const StyledButton = styled(Button)(({ theme, $customVariant }) => ({
  border: $customVariant === "contained" ? "none" : "2px solid #A3E635",
  borderRadius: "8px",
  padding: "12px 20px",
  textTransform: "capitalize",
  fontFamily: "Roboto",
  fontSize: "15px",
  backgroundColor: $customVariant === "contained" ? "#A3E635" : "transparent",
  color: $customVariant === "contained" ? "#000000" : "white",
  fontWeight: "500",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor:
      $customVariant === "contained" ? "#B4F263" : "rgba(163, 230, 53, 0.1)",
    borderColor: $customVariant === "contained" ? "none" : "#A3E635",
  },
  "& .MuiButton-endIcon": {
    marginLeft: "8px",
    marginRight: "0",
  },
}));

const ButtonCommon = ({
  children,
  size = "medium",
  icon, // Icon at the start (optional)
  endIcon, // Custom end icon (optional)
  withAddIcon = false, // Add the "+" icon at the end
  onClick,
  disabled,
  to,
  sx = {},
  fullWidth = true,
  variant = "outlined", // 'outlined' or 'contained'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(); // Call any provided onClick handler first
    }
    if (to) {
      navigate(to); // Navigate to the specified route
    }
  };

  // Determine the end icon to display
  const finalEndIcon = endIcon || (withAddIcon ? <AddIcon /> : null);

  return (
    <StyledButton
      size={size}
      disabled={disabled}
      onClick={handleClick}
      variant={variant}
      $customVariant={variant} // Pass to styled component for styling
      fullWidth={fullWidth}
      sx={{ ...sx }}
      startIcon={icon || null}
      endIcon={finalEndIcon}
    >
      {children}
    </StyledButton>
  );
};

export default ButtonCommon;
